import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import $ from "jquery";

import { accountVerification } from "../../../config/api_calls";
import { jwtDecode } from "jwt-decode";

export default class Verification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      successMessage: "",
    };
  }

  async componentDidMount() {
    let apiHit = await accountVerification(this.props.match.params.token_code);

    // console.log("apiHit.data: ", apiHit.data);

    if (
      apiHit.data.status === 404 ||
      apiHit.data.message === "Invalid Credientials"
    ) {
      this.setState({
        errorMessage:
          "Verification failed. Invalid or expired verification link.",
        successMessage: "",
      });
      setTimeout(() => {
        window.location.replace("/error");
      }, 2000);
    } else if (
      apiHit.data.status === 200 &&
      apiHit.data.message === "success"
    ) {
      const token = apiHit.data.token;

      // 1. Decode token to get expiry
      const decodedToken = jwtDecode(token);
      const tokenExpiryTime = decodedToken.exp * 1000;
      const currentTime = new Date().getTime();

      // 2. Store all cookies
      Cookies.set(
        "tkn__",
        CryptoJS.AES.encrypt(
          apiHit.data.token,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "acn__",
        CryptoJS.AES.encrypt(
          apiHit.data.accountno,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "eml__",
        CryptoJS.AES.encrypt(
          apiHit.data.email,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "comp_nme__",
        CryptoJS.AES.encrypt(
          apiHit.data.comp_name,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "name__",
        CryptoJS.AES.encrypt(
          apiHit.data.name,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "phone__",
        CryptoJS.AES.encrypt(
          apiHit.data.phone,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "title__",
        CryptoJS.AES.encrypt(
          apiHit.data.title,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "usertype__",
        CryptoJS.AES.encrypt(
          apiHit.data.user_type,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "subpoenatype__",
        CryptoJS.AES.encrypt(
          apiHit.data.admin_type,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "userlogo__",
        CryptoJS.AES.encrypt(
          apiHit.data.user_logo,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "useracct__",
        CryptoJS.AES.encrypt(
          apiHit.data.user_accountno,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "usertkn__",
        CryptoJS.AES.encrypt(
          apiHit.data.sub_user_token,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "decimalPoint__",
        CryptoJS.AES.encrypt(
          apiHit.data.decimalPoint.toString(),
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );

      Cookies.set(
        "billing_decimalPoint__",
        CryptoJS.AES.encrypt(
          apiHit.data.billing_decimalPoint.toString(),
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "session_start__",
        CryptoJS.AES.encrypt(
          currentTime.toString(),
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "session_expiry__",
        CryptoJS.AES.encrypt(
          tokenExpiryTime.toString(),
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      localStorage.removeItem("activeMenus");
      localStorage.removeItem("activeSubmenuItem");

      this.setState({
        successMessage:
          "Your account has been verified. Redirecting to dashboard...",
        errorMessage: "",
      });

      if (apiHit.data.admin_type && apiHit.data.admin_type === "Yes") {
        setTimeout(function () {
          window.location.replace("/Compliance");
        }, 1000);
      } else {
        setTimeout(function () {
          window.location.replace("/dashboard");
        }, 2000);
      }
    }
  }

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              {this.state.errorMessage !== "" ? (
                <div className="example-alert">
                  <div className="alert alert-pro alert-danger">
                    <div className="alert-text">
                      <h4>Error</h4>
                      <p>{this.state.errorMessage}</p>
                    </div>
                  </div>
                </div>
              ) : null}

              {this.state.successMessage !== "" ? (
                <div className="example-alert">
                  <div className="alert alert-pro alert-success">
                    <div className="alert-text">
                      <h4>Success</h4>
                      <p>{this.state.successMessage}</p>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="text-center" style={{ marginTop: "20%" }}>
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
